import { faHashtag } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Stack, Typography } from "@mui/material";
import type { TFunction } from "react-i18next";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import type { DurationIcon, DurationUnit } from "api/services/content/schemas/shared";
import { RepetitionsIcon, TimerIcon } from "assets";

const getDurationIcon = (icon: DurationIcon) => {
  switch (icon) {
    case "repetitions":
      return <RepetitionsIcon />;
    case "timer":
      return <TimerIcon />;
    default:
      return <></>;
  }
};

const getDurationUnit = (unit: DurationUnit, t: TFunction) => {
  switch (unit) {
    case "minutes":
      return t("common.minutes");
    case "repetitions":
      return t("common.repetitions");
    case "repetitions_twice":
      return t("common.repetitions");
    case "seconds":
      return t("common.seconds");
    case "steps":
      return t("common.steps");
    default:
      return "";
  }
};

interface Props {
  className?: string;
  duration_icon: DurationIcon | undefined | null;
  duration_unit: DurationUnit | undefined | null;
  reps: string | null;
  sets?: number | null;
}

export const DurationInfo: React.FC<Props> = ({ className, duration_icon, duration_unit, reps, sets }) => {
  const { t } = useTranslation();

  if (!duration_icon || !duration_unit || !reps) {
    return null;
  }

  return (
    <Stack spacing={1}>
      <Container className={className}>
        {getDurationIcon(duration_icon)}
        <Typography>
          {reps} {getDurationUnit(duration_unit, t)}
        </Typography>
      </Container>
      {sets && sets > 1 && (
        <Container className={className}>
          <StyledFontAwesomeIcon icon={faHashtag} />
          <Typography>{t("library.exercises.fields.repeat_times", { sets })}</Typography>
        </Container>
      )}
    </Stack>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const StyledFontAwesomeIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.redesign.o80};
  font-size: 16px;
`;
